<template>
  <div>
    <div class="modal-header-group">
      <span class="host-modal-header-title">{{ $t('journeyBuilder.flow.hostSettings')}}</span>
      <svg
        style="float: inline-end"
        @click="$bvModal.hide('hostSettings')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <div class="host-modal-body">
      <b-form-group>
        <b-form-checkbox
          id="allow_select_idk"
          v-model="hostSetting.allow_not_select_host.value"
          class="hostSettingsCheckbox"
          :class="{
            'disabled-host-checkbox-with-value':
              hostSetting.isDisabledAllowNotSelectHost &&
              hostSetting.allow_not_select_host.value,
          }"
          :disabled="hostSetting.isDisabledAllowNotSelectHost"
        >
          <p
            class="vp-mb-0"
            :class="{
              'disabled-label-color':
                hostSetting.isDisabledAllowNotSelectHost &&
                hostSetting.allow_not_select_host.value,
            }"
          >
           {{ $t('journeyBuilder.flow.host_allowUnknownHostSelection')}}
          </p>
        </b-form-checkbox>

        <!-- show & disable if expected scan on area with current journey  -->
        <p
          class="allow_not_select_host"
          v-if="
            touch_mode &&
            hostSetting.isDisabledAllowNotSelectHost &&
            hostSetting.allow_not_select_host.value
          "
        >
          <b>{{ $t('common.notes.note')}}: </b> {{ $t('journeyBuilder.flow.host_uncheckIfNoVisits')}}
        </p>

        <b-form-checkbox
          id="notify_host"
          class="hostSettingsCheckbox"
          v-model="hostSetting.notify_host.value"
        >
         {{ $t('journeyBuilder.flow.host_notifyHostOnVisitor')}}
        </b-form-checkbox>
      </b-form-group>
    </div>

    <div class="host-modal-footer">
      <button class="saveBtn" @click="submit">{{ $t('common.save')}}</button>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  props: {
    settings: {
      type: Object,
      default: () => {
        return {
          notify_host: {
            id: null,
            value: null,
            metadata: null,
          },
          allow_not_select_host: {
            id: null,
            value: null,
            metadata: null,
          },
        };
      },
    },
    touch_mode: {},
  },
  data() {
    return {
      hostSetting: {
        notify_host: {
          id: null,
          value: null,
          metadata: null,
        },
        allow_not_select_host: {
          id: null,
          value: null,
          metadata: null,
        },
        isDisabledAllowNotSelectHost: null,
      },
    };
  },
  mounted() {
    this.hostSetting = cloneDeep(this.settings);
    console.log(this.hostSetting.isDisabledAllowNotSelectHost);
  },
  methods: {
    submit() {
      this.$emit("updateHost", {
        notify_host: this.hostSetting.notify_host,
        allow_not_select_host: this.hostSetting.allow_not_select_host,
        isDisabledAllowNotSelectHost:
          this.hostSetting.isDisabledAllowNotSelectHost,
      });
      this.$bvModal.hide("hostSettings");
    },
  },
};
</script>
